import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import useUserStore from "../../utils/storeApp";
import CallAPI from "../../services/apiCalls";
import $ from "jquery";

let o = {
  ClientCertificate: false,
  ClientCertificateFindValue: "",
  EndpointAddress: "",
  EndpointName: "",
  Id: null,
  IsValid: false,
  MDNForward: false,
  OrganizationId: null,
  SchemaValidateRequest: false,
  SchemaValidateResponse: false,
  SchemaValidatorOn: false,
  UseConfigFile: false,
  SendXDMBody: false,
};

const XdrSetting = () => {
  const navigate = useNavigate();
  const { userToken, sharedObject, setXDRArr, SetSharedObject, backendTarget } = useUserStore(
    (state) => ({
      userToken: state.userToken,
      sharedObject: state.sharedObject,
      setXDRArr: state.setXDRArr,
      SetSharedObject: state.SetSharedObject,
      backendTarget: state.backendTarget,
    })
  );

  // When the SES/sys admin has the backend toggled to GCP, these XDR options are
  // not supported — hide them and exclude them from update.
  const isGcp = backendTarget === "gcp";
  const [answers, setAnswers] = useState(o);
  const [processing, SetProcessing] = useState(false);
  const [comfirmFlag, SetComfirmFlag] = useState(false);
  const [flag, SetFlag] = useState(false);
  const [frmSubmFlag, SetFrmSubmFlag] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");
  const statusRef = useRef(null);
  const firstFocusRef = useRef(null);
  const previousFocusRef = useRef(null);

  const setAnswer = async (questionId, answer) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };
  
  useEffect(() => {
    const getXDR = async (obj) => {
      let dt = obj;
      let ob = {
        ClientCertificate: dt.clientCertificate,
        ClientCertificateFindValue: dt.clientCertificateFindValue,
        EndpointAddress: dt.endpointAddress,
        EndpointName: dt.endpointName,
        Id: dt.id,
        IsValid: dt.isValid,
        MDNForward: dt.mdnForward,
        OrganizationId: dt.organizationId,
        SchemaValidateRequest: dt.schemaValidateRequest,
        SchemaValidateResponse: dt.schemaValidateResponse,
        SchemaValidatorOn: dt.schemaValidatorOn,
        UseConfigFile: dt.useConfigFile,
        SendXDMBody: dt.sendXDMBody,
      };
      await setAnswers(ob);
    };
    let obj = sharedObject.xdrSettiingObj;
    if (obj?.id) {
      SetFlag(true);
      getXDR(obj);
    } else {
      updateAnswers();
    }
  }, [sharedObject.xdrSettiingObj]);

  // Bootstrap jQuery modal events are the correct hook for focus
  // management when using Bootstrap 4/5 modals � not a custom show/hide state.
  // '#xdrSettingModal' is shown/hidden by Bootstrap imperatively, so we listen
    // to its shown.bs.modal / hidden.bs.modal events to move focus correctly.
  useEffect(() => {
    const modalEl = document.getElementById("xdrSettingModal");
    if (!modalEl) return;

    const onShown = () => {
      previousFocusRef.current = document.activeElement;
      setTimeout(() => firstFocusRef.current?.focus(), 50);
    };
    const onHidden = () => {
      previousFocusRef.current?.focus();
    };

    modalEl.addEventListener("shown.bs.modal", onShown);
    modalEl.addEventListener("hidden.bs.modal", onHidden);
    return () => {
      modalEl.removeEventListener("shown.bs.modal", onShown);
      modalEl.removeEventListener("hidden.bs.modal", onHidden);
    };
  }, []);

  const updateAnswers = async () => {
    SetFlag(false);
    await setAnswers(o);
  };

  const getXDREndPoints = async () => {
    SetProcessing(true);
    let call = "/organization/getAllXDREndPoints";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      setXDRArr(res.data.data);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
    SetProcessing(false);
  };

  const resetValues = async () => {
    let dt = sharedObject.xdrSettiingObj;
    if (!dt?.id) {
      updateAnswers();
    } else {
      let ob = {
        ClientCertificate: dt.clientCertificate,
        ClientCertificateFindValue: dt.clientCertificateFindValue,
        EndpointAddress: dt.endpointAddress,
        EndpointName: dt.endpointName,
        Id: dt.id,
        IsValid: dt.isValid,
        MDNForward: dt.mdnForward,
        OrganizationId: dt.organizationId,
        SchemaValidateRequest: dt.schemaValidateRequest,
        SchemaValidateResponse: dt.schemaValidateResponse,
        SchemaValidatorOn: dt.schemaValidatorOn,
        UseConfigFile: dt.useConfigFile,
        SendXDMBody: dt.sendXDMBody,
      };
      await setAnswers(ob);
    }
  };
 
  const UpadateXdr = async () => {
    SetFrmSubmFlag(true);
    if (!answers?.EndpointName) {
      document.getElementById("EndpointName").scrollIntoView();
      document.getElementById("EndpointName").focus();
      return;
    } else if (!answers?.EndpointAddress) {
      document.getElementById("EndpointAddress").scrollIntoView();
      document.getElementById("EndpointAddress").focus();
      return;
    }
    SetProcessing(true);
    let call = "/organization/updateXDRConfiguration?orgId=";
    const payload = isGcp
      ? {
          // GCP backend does not support these — never send them as enabled.
          ...answers,
          UseConfigFile: false,
          ClientCertificate: false,
          ClientCertificateFindValue: "",
          MDNForward: false,
          SendXDMBody: false,
        }
      : answers;
    const res = await CallAPI(call, payload, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      getXDREndPoints();
      SetFrmSubmFlag(false);
      if (res.data.data.id) SetSharedObject("xdrAdded", res.data.data.id);
      //setAnswers({ ...answers, SendXDMBody: false, MDNForward: false });
      setAnswers(o);
      CloseModal();
      // Announce success to screen readers
      if (statusRef.current)
        statusRef.current.textContent = flag
          ? "XDR configuration updated successfully."
          : "XDR configuration added successfully.";
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
      // Announce failure to screen readers
      if (statusRef.current)
        statusRef.current.textContent = "An error occurred. Please try again.";
    }
  };
  const DeleteXDRConfiguration = async () => {
    SetProcessing(true);
    let call =
      "/organization/deleteXDRConfigurationById?configId=" + answers.Id;
    const res = await CallAPI(call, null, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetComfirmFlag(false);
      SetProcessing(false);
      getXDREndPoints();
      CloseModal();
      // Announce deletion to screen readers
      if (statusRef.current)
        statusRef.current.textContent = "XDR configuration deleted successfully.";
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
      // Announce failure to screen readers
      if (statusRef.current)
        statusRef.current.textContent = "An error occurred. Please try again.";
    }
    };
  
  useEffect(() => {
  let timer;
  if (processing) {
    timer = setTimeout(() => {
      setLoadingText("Working on it...");
    }, 10000);
  } else {
    setLoadingText("Loading...");
  }

  return () => clearTimeout(timer); 
  }, [processing]);

  const CloseModal = () => {
    if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
    }
    // Clear validation errors so they don't persist or reappear on reopen
    SetFrmSubmFlag(false);
    $('#xdrSettingModal').modal('hide');
};

    // Trap focus within the modal while it is open
    const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      CloseModal();
      return;
    }
    if (e.key !== "Tab") return;

    const modal = e.currentTarget;
    const focusable = modal.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  };

  // Dynamic modal title reflects current mode for screen readers
  const modalTitle = comfirmFlag
    ? `Delete ${answers.EndpointName}?`
    : flag
    ? "Edit XDR Config Setting"
    : "Add XDR Config Setting";

  return (
    <div className="XdrSetting">
    <div
        ref={statusRef}
        role="status"
        aria-live="polite"
        aria-atomic="true"
        className="sr-only"
      />
      <div
        className="modal fade"
        id="xdrSettingModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="xdr-setting-modal-title"
        aria-describedby="xdr-setting-modal-body"
        aria-modal="true"
        onKeyDown={handleKeyDown}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="xdr-setting-modal-title">
                {modalTitle}
              </h3>
              <button
                type="button"
                className="close"
                aria-label="Close XDR Config Setting dialog"
                onClick={CloseModal}
                disabled={processing}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" id="xdr-setting-modal-body">
            <p id="xdr-setting-modal-desc" className="sr-only">
                {comfirmFlag
                  ? "Confirm or cancel deletion of this XDR configuration."
                  : flag
                  ? "Edit the XDR endpoint configuration for this organization."
                  : "Add a new XDR endpoint configuration for this organization."}
              </p>
              {comfirmFlag ? (
                <div className="modal-content-form ">
                  <p className="descript2-container">
                    This Outbound XDR configuration will be deleted from all
                    organizations.
                  </p>
                  <p className="ft-wt blk-clr ctr field-wrapper">
                    Are you sure you want to delete <strong>{answers.EndpointName}</strong>?
                  </p>
                </div>
              ) : (
                <div className="modal-content-form">
                  {!isGcp && (
                  <div className="field-wrapper">
                    <input
                      className="form-control spacer-margin5"
                      type="checkbox"
                      id="UseConfigFile"
                      checked={answers.UseConfigFile}
                      value={answers.UseConfigFile}
                      onChange={(el) =>
                        setAnswer("UseConfigFile", el.target.checked)
                      }
                    />
                    <label htmlFor="UseConfigFile">Use Config file</label>
                  </div>
                  )}
                  <div className="field-wrapper">
                    <label htmlFor="EndpointName">
                      Configuration Endpoint Name
                    </label>
                    <input
                      type="text"
                      id="EndpointName"
                      name="endpointName"
                      className="form-control"
                      autoComplete="off"
                      value={answers.EndpointName}
                      disabled={answers.EndpointName && flag}
                      aria-required="true"
                      aria-invalid={!answers?.EndpointName && frmSubmFlag ? "true" : "false"}
                      aria-describedby={!answers?.EndpointName && frmSubmFlag ? "endpoint-name-error" : undefined}
                      onChange={(el) =>
                        setAnswer("EndpointName", el.target.value)
                      }
                      ref={!comfirmFlag ? firstFocusRef : undefined}
                    />
                  </div>
                  {!answers?.EndpointName && frmSubmFlag ? (
                    <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true" >
                      Configuration Endpoint Name is required
                    </div>
                  ) : null}
                  <div className="field-wrapper">
                    <label htmlFor="EndpointAddress">Endpoint URL</label>
                    <input
                      type="text"
                      className="form-control"
                      id="EndpointAddress"
                      name="endpointAddress"
                      autoComplete="off"
                      disabled={answers.UseConfigFile}
                      aria-disabled={answers.UseConfigFile}
                      value={answers.EndpointAddress}
                      onChange={(el) =>
                        setAnswer("EndpointAddress", el.target.value)
                      }
                      aria-required="true"
                      aria-invalid={!answers?.EndpointAddress && frmSubmFlag ? "true" : "false"}
                      aria-describedby={!answers?.EndpointAddress && frmSubmFlag ? "endpoint-address-error" : undefined}
                    />
                  </div>
                  {!answers.EndpointAddress && frmSubmFlag ? (
                    <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true" >
                      Endpoint URL is required
                    </div>
                  ) : null}
                  {!isGcp && (
                  <div className="field-wrapper">
                    <label htmlFor="ClientCertificateFindValue">
                      Use Certificate
                    </label>
                    <input
                      type="text"
                      id="ClientCertificateFindValue"
                      name="clientCertificateFindValue"
                      className="form-control"
                      autoComplete="off"
                      placeholder="Optional"
                      disabled={answers.UseConfigFile}
                      aria-disabled={answers.UseConfigFile}
                      value={answers.ClientCertificateFindValue}
                      onChange={(el) =>
                        setAnswer("ClientCertificateFindValue", el.target.value)
                      }
                    />
                  </div>
                  )}
                  <fieldset className="field-wrapper">
                    <legend className="sr-only">Message delivery options</legend>
                    {!isGcp && (
                    <div>
                      <input
                        className="form-control spacer-margin5"
                        type="checkbox"
                        id="SendXDMBody"
                        name="sendXDMBody"
                        value={answers.SendXDMBody}
                        checked={answers.SendXDMBody}
                        onChange={(el) =>
                          setAnswer("SendXDMBody", el.target.checked)
                        }
                      />
                      <label htmlFor="SendXDMBody">Deliver message body for XDM messages</label>
                    </div>
                    )}
                    {!isGcp && (
                    <div>
                      <input
                        className="form-control spacer-margin5"
                        type="checkbox"
                        id="MDNForward"
                        name="mdnForward"
                        value={answers.MDNForward}
                        checked={answers.MDNForward}
                        onChange={(el) =>
                          setAnswer("MDNForward", el.target.checked)
                        }
                      />
                      <label htmlFor="MDNForward">Deliver MDNs</label>
                    </div>
                    )}
                  </fieldset>
                </div>
              )}
            </div>
            <div className="modal-footer">
              {comfirmFlag ? (
                <>
                  <button
                   ref={firstFocusRef}
                    type="button"
                    className="btn btn-success"
                    onClick={(e) => DeleteXDRConfiguration()}
                    disabled={processing}
                    aria-busy={processing}
                  >
                    {processing ? "Processing..." : "Confirm"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={(e) =>{
                        CloseModal();
                        SetComfirmFlag(false);
                    }}
                    disabled={processing}
                  >
                    Cancel
                  </button>
                </>
              ) : (
                <>
                  <button
                    ref={firstFocusRef}
                    type="button"
                    className="btn btn-success"
                    onClick={UpadateXdr}
                    disabled={processing}
                    aria-busy={processing}
                    aria-label={
                      processing
                        ? flag ? "Updating, please wait" : "Adding, please wait"
                        : flag ? "Update XDR configuration" : "Add XDR configuration"
                    }
                  >
                   {processing ? (flag ? "Updating..." : "Adding...") : (flag ? "Update" : "Add")}
                  </button>
                  {flag ? (
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={(e) => SetComfirmFlag(true)}
                      disabled={processing}
                      aria-label={`Delete XDR configuration: ${answers.EndpointName || "this configuration"}`}
                    >
                      Delete
                    </button>
                  ) : null}
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    disabled={processing}
                    onClick={() => {
                        resetValues();
                        CloseModal();
                    }}
                  >
                    Cancel
                  </button>
                   {processing && (
                        <div 
                            className="loader-container" 
                            role="status" 
                            aria-live="polite" 
                            aria-atomic="true"
                            aria-labelledby="xdr-loader-id"
                        >
                          <div className="spinner" aria-hidden="true"></div>
                          <div className="loading-text" id="xdr-loader-id">{loadingText}</div>
                        </div>
                      )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default XdrSetting;
